module.exports = __webpack_public_path__ + "assets/certificate_pdf/p_01.c06a436a.pdf";